import React, { useState } from 'react';
import { TextInputProps as RNTextInputProps } from 'react-native';
import { isDefined } from '@app/helpers/kindOf';
import { StyledInputs, StyledTextInputProps } from '../styled/form/Inputs';
import { StyledForms } from '../styled/form/Form';
import { useInput } from '@app/hooks/useInput';
import { normalize } from '@app/helpers';
import { worksansoxford } from '@app/style';
import { theme } from '@app/theme';
import { HelperText } from '../styled/form/Label';

// @ts-expect-error
export interface TextInputProps extends RNTextInputProps, StyledTextInputProps, React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  name: string;
  label?: string;
  helper?: string;
}

export const NumberInput = ({ label, name, helper, ...props }: TextInputProps) => {
  const { field, error, formState } = useInput(name);

  const [blur, setBlur] = useState(true);

  const isFilled = isDefined(field.value);

  return (
    <StyledInputs.Holder>
      {label && <StyledInputs.Label isFilled={isFilled} isDirty={formState.isDirty} isBlurred={blur}>
        {label}
      </StyledInputs.Label>}

      {!!error && (
        <StyledForms.Error>
          <StyledForms.ErrorLabel>
            {error}
          </StyledForms.ErrorLabel>
        </StyledForms.Error>
      )}

      <input
        ref={field.ref}
        type="number"
        // @ts-expect-error
        onWheel={(e) => e.target.blur()}
        value={field.value ?? ''}
        // @ts-expect-error
        style={{
          height:
            props.size === "large" ? normalize(92) :
              props.size === "small" ? normalize(58) :
                normalize(76),
          ...worksansoxford,
          fontSize: normalize(21),
          fontWeight: '500',
          aspectRatio: props.round ? "1/1" : undefined,
          color: theme.colors.babypowder,
          textAlign: props.center ? 'center' : 'left',
          borderRadius: props.inside ? 0 : props.round ? 100 : 5,
          backgroundColor: props.size === "small" ? theme.colors.oxfordblue : 'rgba(240, 249 , 252, .04)',
          padding: props.nude ? 0 : props.size === "small" ? normalize(21) : normalize(34),
          border: 'none',
          outlineWidth: 0,
          borderBottomColor: props.nude ? 'transparent' : props.error ? theme.colors.crimson : props.isBlurred ? 'rgba(255,255,255,0)' : theme.colors.celadonblue,
          borderBottomWidth: props.nude ? 0 : 3,
          opacity: 1,
          width: '100%',
          zIndex: 999,
        }}
        {...props}
        onChange={(e) => field.onChange(e.target.value === '' ? null : e.target.valueAsNumber)}
        onBlur={() => setBlur(true)}
        onFocus={() => setBlur(false)}
      />

      {helper && (
        <HelperText>
          {helper}
        </HelperText>
      )}
    </StyledInputs.Holder>
  );
};
